"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var SteeringBehavior_1 = require('./SteeringBehavior');
/**
 * {@code GroupBehavior} is the base class for the steering behaviors that take into consideration the agents in the game world
 * that are within the immediate area of the owner. This immediate area is defined by a {@link Proximity} that is in charge of
 * finding and processing the owner's neighbors through the given {@link ProximityCallback}.
 *
 * @param <T> Type of vector, either 2D or 3D, implementing the {@link Vector} interface
 *
 * @author davebaol
 */
var GroupBehavior = (function (_super) {
    __extends(GroupBehavior, _super);
    /**
     * Creates a GroupBehavior for the specified owner and proximity.
     * @param owner the owner of this behavior.
     * @param proximity the proximity to detect the owner's neighbors
     */
    function GroupBehavior(owner, proximity) {
        _super.call(this, owner);
        this.proximity = proximity;
    }
    /** Returns the proximity of this group behavior */
    GroupBehavior.prototype.getProximity = function () {
        return this.proximity;
    };
    /**
     * Sets the proximity of this group behavior
     * @param proximity the proximity to set
     */
    GroupBehavior.prototype.setProximity = function (proximity) {
        this.proximity = proximity;
    };
    return GroupBehavior;
}(SteeringBehavior_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = GroupBehavior;
//# sourceMappingURL=GroupBehavior.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/pawsong/gdx-ai.js/lib/steer/GroupBehavior.js
 ** module id = 889
 ** module chunks = 0
 **/